// extracted by mini-css-extract-plugin
export default {"container":"XQvCQC","thumbnail-wrapper":"wabSiK","thumbnailWrapper":"wabSiK","prev-button":"ocrXY1","prevButton":"ocrXY1","next-button":"WtMU16","nextButton":"WtMU16"};